import { List, Record  } from 'immutable';

export const NotificationList = new Record({
  id: null,
  isNew: true,
  isPending: false,
  notifiactionIds: new List(),
  count_unread: 0,
  update_at: new Date(),
});
